import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import {
  BreadcrumbService,
  InstructionInfo,
  BreadcrumbPortal,
} from './breadcrumb.service';
import { FormatService } from '../../query';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rdo-breadcrumb',
  templateUrl: 'breadcrumb.component.html',
  styleUrls: ['breadcrumb.component.scss'],
  standalone: false,
})
export class BreadcrumbComponent implements OnInit, OnDestroy, AfterViewInit {
  private instructionsSubscription: Subscription;
  private portalsSubscription: Subscription;
  instructions: Array<InstructionInfo>;
  portals: Array<BreadcrumbPortal> = [];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private formatService: FormatService
  ) {}

  ngOnInit() {
    this.instructions = this.breadcrumbService.instructions;
    this.instructionsSubscription = this.breadcrumbService.onChange.subscribe(
      (i) => {
        this.instructions = i;
      }
    );

    // Subscribe to portal changes
    this.portalsSubscription = this.breadcrumbService.onPortalsChange.subscribe(
      (portalsMap) => {
        this.portals = Array.from(portalsMap.values());
      }
    );
  }

  ngAfterViewInit() {
    // Initialize with any existing portals
    this.portals = Array.from(this.breadcrumbService.portals.values());
  }

  ngOnDestroy() {
    if (this.instructionsSubscription) {
      this.instructionsSubscription.unsubscribe();
    }
    if (this.portalsSubscription) {
      this.portalsSubscription.unsubscribe();
    }
  }

  translateTitle(title: string) {
    return this.formatService.translateAndFormat(title);
  }
}
